import { Pagination } from '@mantine/core';

type TablePaginationProps = {
  activePage: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export function TablePagination({ activePage, onChange, totalPages }: TablePaginationProps) {
  if (totalPages === 1 || isNaN(totalPages)) {
    return null;
  }

  return (
    <Pagination
      c='black'
      color='teal.6'
      mb='xs'
      value={activePage}
      onChange={onChange}
      total={totalPages}
      styles={{
        control: {
          color: 'black',
          border: '1px solid var(--mantine-color-dark-9)',
        },
      }}
      className='self-end'
    />
  );
}
